import { Alert, Box, Icon, Text } from '@nimbus-ds/components';
import { CloseIcon } from '@nimbus-ds/icons';
import { Trans } from 'react-i18next';
import { useStorage } from 'commons/hooks';
import useNuvemEnvioTranslations from 'domains/NuvemEnvioCommons/hooks/useNuvemEnvioTranslations/useNuvemEnvioTranslations';

function OrdersSafariAlert() {
  const t = useNuvemEnvioTranslations();

  const [dismissed, setDismissed, loaded] = useStorage(
    'print-documents-page-safari-alert-dismissed',
    false,
  );

  const showAlert = loaded && !dismissed;

  return (
    <Alert appearance="warning" show={showAlert}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Text>
          <Trans
            t={t}
            i18nKey="printPageDocument.alert.safari"
            components={{
              b: <b />,
            }}
          />
        </Text>

        <Icon
          onClick={() => setDismissed(true)}
          source={<CloseIcon />}
          color="neutral-textDisabled"
          cursor="pointer"
        />
      </Box>
    </Alert>
  );
}

export default OrdersSafariAlert;
